import { Lock, FileSearch, Database, ShieldCheck, Building2, UserCog } from "lucide-react";

const ITEMS = [
  { Icon: Lock, label: "Role-Based Access" },
  { Icon: FileSearch, label: "Audit Logs" },
  { Icon: Database, label: "Data Retention Controls" },
  { Icon: ShieldCheck, label: "Encrypted Storage" },
  { Icon: Building2, label: "Multi-Market Separation" },
  { Icon: UserCog, label: "Admin Permission Controls" },
];

export default function Security() {
  return (
    <section data-testid="security-section" className="section-y relative">
      <div className="container-x">
        <div className="max-w-3xl reveal mb-10">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Security</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Designed for enterprise-grade security and operational reliability.
          </h2>
        </div>

        <div className="flex flex-wrap gap-3 reveal">
          {ITEMS.map(({ Icon, label }) => (
            <div
              key={label}
              className="inline-flex items-center gap-2 rounded-full bg-[#171717] border border-white/10 px-4 py-2.5 text-sm text-white"
            >
              <Icon size={14} className="text-[#FDBA74]" />
              {label}
            </div>
          ))}
        </div>

        <p className="reveal mt-6 text-xs text-[#94A3B8] max-w-2xl">
          LocateOS is designed with enterprise security requirements in mind. Contact us for detailed security documentation.
        </p>
      </div>
    </section>
  );
}
